 // Get all elements with the class "openPopup"
const openPopupLinks = document.querySelectorAll('.openPopup');

// Loop through each "openPopup" link and add event listeners
openPopupLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();

    // Get the value of the "data-popup" attribute to identify the target popup
    const targetPopupId = this.getAttribute('data-popup');
    const targetOverlayId = `overlay${targetPopupId.slice(-1)}`;

    // Display the overlay and show the target popup
    document.getElementById(targetOverlayId).style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.getElementById(targetPopupId).style.right = '0';
  });
});

// Get all elements with the class "closePopup"
const closePopupButtons = document.querySelectorAll('.closePopup');

// Loop through each "closePopup" button and add event listeners
closePopupButtons.forEach(button => {
  button.addEventListener('click', closePopup);
});

// Get all overlay elements
const overlays = document.querySelectorAll('.overlay');

// Add event listener to each overlay to close popup when clicked
overlays.forEach(overlay => {
  overlay.addEventListener('click', closePopup);
});

// Function to close the popup
function closePopup() {
  // Find the corresponding popup container and overlay id
  let popupContainer, overlayId;
  if (this.classList.contains('overlay')) {
    overlayId = this.id;
    const index = overlayId.slice(-1);
    popupContainer = document.getElementById(`popup${index}`);
  } else {
    popupContainer = this.closest('.popupContainer');
    overlayId = `overlay${popupContainer.id.slice(-1)}`;
  }

  // Hide the overlay and close the popup
  document.getElementById(overlayId).style.display = 'none';
  document.body.style.overflow = '';
  popupContainer.style.right = '-480px';
}
